import React, { useState } from 'react';
import UploadSection from '../components/UploadSection/UploadSection';
import './SettingsPage.css';

const SettingsPage = () => {
  const [images, setImages] = useState({
    logo: '/images/logo.png',
    favicon: '/images/favicon.ico',
    loginBackground: '/images/login-background.png',
    frontpageBackground: '/images/frontpage-background.png',
    registrationBackground: '/images/registration-background.png',
  });

  const appendTimestamp = (path) => `${path}?t=${new Date().getTime()}`;

  const sections = [
    { title: 'Logo', apiEndpoint: '/Upload/upload-logo', key: 'logo' },
    { title: 'Favicon', apiEndpoint: '/Upload/upload-favicon', key: 'favicon' },
    { title: 'Login Background', apiEndpoint: '/Upload/upload-login-background', key: 'loginBackground' },
    { title: 'FrontPage Background', apiEndpoint: '/Upload/upload-frontpage-background', key: 'frontpageBackground' },
    { title: 'Registration Background', apiEndpoint: '/Upload/upload-registration-background', key: 'registrationBackground' },
  ];

  return (
    <div className="settings-container">
      <h1>Settings</h1>
      <div className="current-images">
        {sections.map(({ title, apiEndpoint, key }) => (
          <div key={key} className="image-section">
            <h3>{title}</h3>
            {images[key] && <img src={appendTimestamp(images[key])} alt={title} className="current-image" />}
            <UploadSection
              title={title}
              apiEndpoint={apiEndpoint}
              onUploadSuccess={(path) => setImages((prev) => ({ ...prev, [key]: path }))}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default SettingsPage;
